import type { AuditEventApi } from '@env0/audit-service/api';
import type { HttpClient } from 'services/api-client/client';
import type { AuditLog } from 'types/api.types';
import { returnData } from 'services/api-client/client';
import isEmpty from 'lodash/isEmpty';

type AuditLogQueryParams = AuditEventApi.FetchAuditLogs.Request.QueryParams;

export type AuditLogFilters = Pick<
  AuditLogQueryParams,
  'from' | 'to' | 'userId' | 'projectId' | 'entityId' | 'order'
> & {
  actionNames?: string[];
};

export default (client: HttpClient) => ({
  findByOrganizationId: (organizationId: string, pageKey?: string, { actionNames, ...filters }: AuditLogFilters = {}) =>
    client
      .get<{ events: AuditLog[]; nextPageKey?: string }>('audit/events', {
        params: {
          organizationId,
          offset: pageKey,
          ...filters,
          actionNames: isEmpty(actionNames) ? undefined : actionNames?.join(',')
        }
      })
      .then(returnData)
});
